import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import Route, { RoutePreview } from "@mapmycustomers/shared/types/entity/Route";
import { UserRef } from "@mapmycustomers/shared/types/User";

import type { EditorActions } from "./editor/actions";
import type { RouteLeadFinderActions } from "./leadFinder/actions";
import type { MapActions } from "./map/actions";
import type { ViewActions } from "./view/actions";

export * from "./editor/actions";
export * from "./leadFinder/actions";
export * from "./map/actions";
export * from "./view/actions";

export const initializeRouteView = createAsyncAction(
  "route/routeDetails/initialize/request",
  "route/routeDetails/initialize/success",
  "route/routeDetails/initialize/failure"
)<
  {
    callback?: (bounds: google.maps.LatLngBounds) => void;
    routeId: Route["id"];
  },
  {
    route: Route;
    routePreview?: RoutePreview;
  },
  void
>();

export const initializeRouteCreate = createAsyncAction(
  "route/routeDetails/initializeCreate/request",
  "route/routeDetails/initializeCreate/success",
  "route/routeDetails/initializeCreate/failure"
)<
  {
    callback?: (location?: GeolocationCoordinates) => void;
    date: Date;
  },
  { date: Date; owner: UserRef },
  void
>();

export const initializeRouteEdit = createAsyncAction(
  "route/routeDetails/initializeEdit/request",
  "route/routeDetails/initializeEdit/success",
  "route/routeDetails/initializeEdit/failure"
)<
  {
    callback?: (bounds: google.maps.LatLngBounds) => void;
    routeId: Route["id"];
  },
  {
    route: Route;
    routePreview?: RoutePreview;
  },
  void
>();

export const clearRouteDetails = createAction("route/routeDetails/clear")();

export type Actions =
  | ActionType<
      | typeof clearRouteDetails
      | typeof initializeRouteCreate
      | typeof initializeRouteEdit
      | typeof initializeRouteView
    >
  | EditorActions
  | MapActions
  | RouteLeadFinderActions
  | ViewActions;
